import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-the-j05-chat-formas" }
const _hoisted_2 = { class: "c-common-inner" }
const _hoisted_3 = { class: "p-the-j05-chat-formas__inner" }
const _hoisted_4 = {
  ref: "formGroupElement",
  class: "p-the-j05-chat-formas__body"
}
const _hoisted_5 = {
  ref: "textareaElement",
  class: "p-the-j05-chat-formas__message"
}
const _hoisted_6 = { class: "p-the-j05-chat-formas__help" }
const _hoisted_7 = { class: "p-the-j05-chat-formas__submit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            ref: "form",
            "validation-schema": _ctx.schema,
            class: "p-the-j05-chat-formas__col",
            onSubmit: _ctx.submit
          }, {
            default: _withCtx(({ meta }) => [
              (_ctx.setMeta(meta))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_5, [
                _createVNode(_component_Field, {
                  name: "message",
                  "validate-on-blur": false,
                  "validate-on-change": false
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_InputTextarea, {
                      ref: "messageTextarea",
                      id: "message",
                      value: value,
                      onInput: handleChange,
                      error: errorMessage,
                      "add-style": { backgroundColor: '#ffffff'},
                      onKeyupShiftEnter: _ctx.doSend
                    }, null, 8, ["value", "onInput", "error", "onKeyupShiftEnter"]),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "p-cmt" }, " 全半角500文字以内 ", -1)),
                      _createVNode(_component_SmallText, {
                        size: 11,
                        class: "p-the-j05-chat-formas__message__note"
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode(" Enter で改行、Shift + Enter で送信できます。 ", -1)
                        ])),
                        _: 1,
                        __: [0]
                      })
                    ]),
                    _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage), 1)
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, errorMessage]
                    ])
                  ]),
                  _: 1
                })
              ], 512),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ButtonMain, {
                  type: "submit",
                  disabled: !meta?.valid || !meta?.dirty,
                  style: _normalizeStyle(
                  !meta?.valid || !meta?.dirty
                    ? { background: '#e0e0e0' }
                    : { background: _ctx.colorCode }
                )
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" 送信 ", -1)
                  ])),
                  _: 2,
                  __: [2]
                }, 1032, ["disabled", "style"])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema", "onSubmit"])
        ], 512)
      ])
    ])
  ]))
}